export function getParametersFromQueryString(queryString: string): {
  [key: string]: string | null;
} {
  let result = queryString;
  if (result.startsWith('?')) {
    result = result.substr(1);
  }
  const objects: Record<string, string> = {};
  result.split('&').forEach(value => {
    const keyValues = value.split('=');
    objects[keyValues[0]] = keyValues[1];
  });
  return objects;
}

export interface QueryStringObject {
  [key: string]: string | number | boolean | undefined | null;
}
/**
 * Creates a query string from an object, excluding undefined or null values
 * @param obj Flat object with string keys - values are resolved as strings
 */
export function queryStringFromObject(
  obj: QueryStringObject = {}
): string | void {
  if (typeof obj === 'object') {
    const queryString = Object.keys(obj)
      .reduce<string[]>((params, key) => {
        if (obj[key] != null) {
          params.push(`${key}=${obj[key]}`);
        }
        return params;
      }, [])
      .join('&');
    if (queryString) {
      return `?${queryString}`;
    }
  }
}
